export var selectIsListLoading = function selectIsListLoading(state) {
  return state.favoritesAssignWidget.isListLoading;
};